'use client';

import { useTranslations } from 'next-intl';

import { PageError } from '@/components/Error';

/**
 * 404 Not Found page.
 *
 * This component renders within the root layout, so it has access to the
 * NextIntlClientProvider and translation context.
 */
function NotFound() {
  const translate = useTranslations();

  return (
    <PageError
      title={translate('errorPages.notFound.pageTitle')}
      description={translate('errorPages.notFound.pageDescription')}
    />
  );
}

export default NotFound;
